import { PageHeader } from "../../../components/AppLayout";
import { Card } from "../../../components/shared/Card";
import { EmptyState } from "../../../components/shared/EmptyState";

export function AdminSkillsModeration() {
  return (
    <>
      <PageHeader title="Skill moderation" subtitle="Review pending skills before they go public." />
      <Card>
        <EmptyState title="Moderation queue in Phase 4" />
      </Card>
    </>
  );
}
